
import React from "react";
import { Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ContactUs = () => {
  return (
    <div className="bg-background min-h-screen">
      <div className="container max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12">
        <h1 className="text-3xl font-bold mb-6 text-foreground">Contact Us</h1>
        
        <Card className="shadow-sm">
          <CardContent className="p-6">
            <h2 className="text-xl font-semibold mb-4 text-foreground">Get in Touch</h2>
            <p className="text-muted-foreground mb-6">
              We'd love to hear from you. Please use the contact information below to reach us.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="min-w-10 mt-1">
                  <Phone className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="font-medium text-foreground">Phone the founders</p>
                  <p className="text-muted-foreground">Utkarsh Gupta: +91 9717100100</p>
                  <p className="text-muted-foreground">Varun Kasisomayajula: +91 9100167640</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="min-w-10 mt-1">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="font-medium text-foreground">Email</p>
                  <p className="text-muted-foreground">contact@testera.ai</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ContactUs;
